export default class EditorState{

    static LOADING = 1;
    static BROWSING = 2;
    static EDITING = 3;

}